import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, Row } from '@sm/wds-react';
import { T } from '@sm/intl';
import NavSubmenuCopy from '../../../copy/NavSubmenuCopy';

export const ByNeedSubMenu = ({ children }) => {
  return (
    <Grid>
      <Typography
        variant="cardTitle"
        color="dark"
        className="sm-nav-submenu__by-need-title"
      >
        <T desc={NavSubmenuCopy.BY_NEED} />
      </Typography>
      <Row className="submenu-lo--row">{children}</Row>
    </Grid>
  );
};

export default ByNeedSubMenu;

ByNeedSubMenu.propTypes = {
  children: PropTypes.node.isRequired,
};
